function getUnitId(unitApiUrl, includeSystemCode = true) {
    const UNIT_API_URL_PREFIX = '/units/';
    const UNIT_API_URL_WITH_SYSTEM_CODE_PREFIX = '/units/xxxx/';

    if (!unitApiUrl || unitApiUrl.indexOf(UNIT_API_URL_PREFIX) === -1) {
        return null;
    }

    return includeSystemCode
        ? unitApiUrl.substring(UNIT_API_URL_PREFIX.length)
        : unitApiUrl.substring(UNIT_API_URL_WITH_SYSTEM_CODE_PREFIX.length);
}

export default getUnitId;
